<template>
  <div class="container">
    <div class="businessresource-listing">
      <div class="businessresource-listing-controls pe-lg-5">
        <div class="d-flex justify-content-between flex-lg-column">
          <business-resource-filters :filterGroups="filterGroups" :results="filteredBusinessResources" :currentQuery="currentQuery" :showItemCount="1">
            <template v-for="(_, name) in $slots" v-slot:[name]="slotData"><slot :name="name" v-bind="slotData" /></template>
          </business-resource-filters>
        </div>
      </div>

      <div class="businessresource-listing-results businessresource-card-container" aria-live="polite">
        <div class="row">
          <div v-for="businessResource in filteredBusinessResources" class="col-6 col-lg-4 mb-4">
            <business-resource-result :businessResource="businessResource">
              <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
                <slot :name="name" v-bind="slotData" />
              </template>
            </business-resource-result>
          </div>
        </div>
        <button class="btn btn-secondary d-block mx-auto" v-if="displayLoadMoreButton" v-on:click="numberShown += increment">Load More</button>
      </div>
    </div>
  </div>

</template>

<script>
  import BusinessResourceFilters from './business-resource-listing/business-resource-filters.vue';
  import BusinessResourceResult from './business-resource-listing/business-resource-result.vue';

  

  import Globals from '../../scripts/globals';

  export default {
    components: {
      'business-resource-filters': BusinessResourceFilters,
      'business-resource-result': BusinessResourceResult
    },
    data() {
      let searchParams = new URLSearchParams(window.location.search)
      let d = window.wf.businessResourceListing
      d.currentQuery ??= {};
      d.currentQuery.filters ??= {};
      d.filterGroups.forEach((grp) => {
        if (!d.currentQuery.filters[grp.id] || d.currentQuery.filters[grp.id].length == 0) {
          d.currentQuery.filters[grp.id] = searchParams.get(`filter_${grp.id}`) ? searchParams.get(`filter_${grp.id}`).split(';') : [];
        }
        // ensure all items have at least an empty filter
        d.businessResources.forEach((item) => {
          if (!item.filterValues[grp.id]) {
            item.filterValues[grp.id] = [];
          }
        })
      });
      d.numberShown ??= -1;
      d.increment ??= d.numberShown;
      return d;
    },
    computed: {
      filteredBusinessResources() {
        if (this.numberShown > -1) {
          return this.filterByQuery(this.currentQuery).filter((el, index) => index < this.numberShown);
        } else {
          return this.filterByQuery(this.currentQuery);
        }
      },
      displayLoadMoreButton() {
        if (this.businessResources.length > this.numberShown && this.numberShown > -1) {
          return true;
        }
        return false;
      }
    },
    watch: {
      currentQuery: {
        handler: function() {
          this.updateLocation();
        },
        deep: true
      }
    },
    methods: {
      filterByQuery(query) {
        let filtered = this.businessResources.filter((item) => {
          let match = true;
          this.filterGroups.forEach((grp) => {
            let groupMatch = (query.filters[grp.id].length == 0) ? true : (item.filterValues[grp.id].filter((b) => query.filters[grp.id].includes(b))).length > 0;
            match &&= groupMatch;
          });
          return match;
        })
        return filtered;
      },
      updateLocation() {
        let queryString = new URLSearchParams();
        this.filterGroups.forEach((grp) => {
          if (this.currentQuery.filters[grp.id] && this.currentQuery.filters[grp.id].length) {
            queryString.append(`filter_${grp.id}`, this.currentQuery.filters[grp.id].join(';'))
          }
        })
        window.history.replaceState(window.history.state, null, `${window.location.pathname}?${queryString.toString()}`);
      }
    }
  }
</script>
